import styles from "./Addresses.module.css";
import Item from "./Item/Item";
import { ReactComponent as EditIcon } from "../../../../assets/svg/edit.svg";
import { ReactComponent as PlusIcon } from "../../../../assets/svg/plus.svg";
import ShippingOptions from "../ShippingOptions/ShippingOptions";

import AddEditAddress from "../../../pages/Address/newAddress/AddEditAddress/AddEditAddress";
import useAddress from "../../../pages/Address/newAddress/useAddress";
import { useTranslation } from "react-i18next";
import Loading from "../../Loading/Loading";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";

const Addresses = ({
  selectedAddress,
  setSelectedAddress,
  selectedShippingOption,
  setSelectedShippingOption,
  shippingMethods,
  onSubmit,
  optionLoading,
}) => {
  const { t } = useTranslation();
  const navigate = useLangNavigate();
  const {
    addresses,
    loading,
    onSelectLocation,
    onCreateModal,
    onSubmit: onSubmitAddress,
  } = useAddress();

  return (
    <>
      <div className={styles.Addresses}>
        <div className={styles.AddressesContent}>
          {loading && (
            <div className="text-center mt-2">
              <Loading />
            </div>
          )}
          {!!addresses && !loading ? (
            <div className={styles.AddressesContainer}>
              <div className={styles.AddressTitle}>
                <h2>{t("cart.address_my")}</h2>
                {addresses.length > 0 && (
                  <div
                    className={styles.editAddress}
                    onClick={() => navigate(`/address/d/`)}
                  >
                    <EditIcon />
                  </div>
                )}
              </div>
              {addresses.reverse().map((addressItem, addressIndex) => {
                return (
                  <Item
                    {...addressItem}
                    onClick={() => {
                      setSelectedAddress(addressItem);
                      setSelectedShippingOption(shippingMethods[0]?.id ?? null);
                      onSubmit(addressItem);
                    }}
                    active={selectedAddress?.id === addressItem.id}
                    last={addressIndex === addresses.length - 1}
                    key={addressItem.id}
                  />
                );
              })}
              <div className={styles.AddAddressButton} onClick={onCreateModal}>
                <div className={styles.AddAddressButtonIconContainer}>
                  <PlusIcon />
                </div>
                <span>{t("cart.address_different")}</span>
              </div>
            </div>
          ) : null}
          {optionLoading ? (
            <div className="mt-5">
              <Loading />
            </div>
          ) : (
            shippingMethods.length > 0 && (
              <div className="w-full">
                <ShippingOptions
                  shippingOptions={shippingMethods}
                  selectedShippingOption={selectedShippingOption}
                  setSelectedShippingOption={setSelectedShippingOption}
                />
              </div>
            )
          )}
        </div>
      </div>
      <AddEditAddress
        onSelectLocation={onSelectLocation}
        onSubmit={onSubmitAddress}
      />
    </>
  );
};

export default Addresses;
